import { ServiceProto } from 'tsrpc-proto';
import { ReqAnalyticsQuery, ResAnalyticsQuery } from './editor/PtlAnalyticsQuery';
import { ReqCommercialAnalyticsQuery, ResCommercialAnalyticsQuery } from './editor/PtlCommercialAnalyticsQuery';
import { ReqDataDelete, ResDataDelete } from './editor/PtlDataDelete';
import { ReqDataDistinct, ResDataDistinct } from './editor/PtlDataDistinct';
import { ReqDataFind, ResDataFind } from './editor/PtlDataFind';
import { ReqDataInsert, ResDataInsert } from './editor/PtlDataInsert';
import { ReqDataUpdate, ResDataUpdate } from './editor/PtlDataUpdate';
import { ReqDisableAdRevenueConfig, ResDisableAdRevenueConfig } from './editor/PtlDisableAdRevenueConfig';
import { ReqFileDelete, ResFileDelete } from './editor/PtlFileDelete';
import { ReqFileUpload, ResFileUpload } from './editor/PtlFileUpload';
import { ReqGetAdRevenueConfigs, ResGetAdRevenueConfigs } from './editor/PtlGetAdRevenueConfigs';
import { ReqGetAdRevenueReportRecords, ResGetAdRevenueReportRecords } from './editor/PtlGetAdRevenueReportRecords';
import { ReqGetCurrentUser, ResGetCurrentUser } from './editor/PtlGetCurrentUser';
import { ReqGetManagedUsers, ResGetManagedUsers } from './editor/PtlGetManagedUsers';
import { ReqGetTencentAdsRetentionOverview, ResGetTencentAdsRetentionOverview } from './editor/PtlGetTencentAdsRetentionOverview';
import { ReqGetTencentAdsRetentionReports, ResGetTencentAdsRetentionReports } from './editor/PtlGetTencentAdsRetentionReports';
import { ReqRetryAdRevenueReports, ResRetryAdRevenueReports } from './editor/PtlRetryAdRevenueReports';
import { ReqRetryTencentAdsRetentionReports, ResRetryTencentAdsRetentionReports } from './editor/PtlRetryTencentAdsRetentionReports';
import { ReqSaveAdRevenueConfig, ResSaveAdRevenueConfig } from './editor/PtlSaveAdRevenueConfig';
import { ReqSaveTencentAdsRetentionConfig, ResSaveTencentAdsRetentionConfig } from './editor/PtlSaveTencentAdsRetentionConfig';
import { ReqUpdateManagedUser, ResUpdateManagedUser } from './editor/PtlUpdateManagedUser';
import { ReqUploadAssetBundle, ResUploadAssetBundle } from './editor/PtlUploadAssetBundle';
import { ReqLoginWithToken, ResLoginWithToken } from './PtlLoginWithToken';
import { ReqLoginWithUsername, ResLoginWithUsername } from './PtlLoginWithUsername';
import { ReqRegister, ResRegister } from './PtlRegister';

export interface ServiceType {
    api: {
        "editor/AnalyticsQuery": {
            req: ReqAnalyticsQuery,
            res: ResAnalyticsQuery
        },
        "editor/CommercialAnalyticsQuery": {
            req: ReqCommercialAnalyticsQuery,
            res: ResCommercialAnalyticsQuery
        },
        "editor/DataDelete": {
            req: ReqDataDelete,
            res: ResDataDelete
        },
        "editor/DataDistinct": {
            req: ReqDataDistinct,
            res: ResDataDistinct
        },
        "editor/DataFind": {
            req: ReqDataFind,
            res: ResDataFind
        },
        "editor/DataInsert": {
            req: ReqDataInsert,
            res: ResDataInsert
        },
        "editor/DataUpdate": {
            req: ReqDataUpdate,
            res: ResDataUpdate
        },
        "editor/DisableAdRevenueConfig": {
            req: ReqDisableAdRevenueConfig,
            res: ResDisableAdRevenueConfig
        },
        "editor/FileDelete": {
            req: ReqFileDelete,
            res: ResFileDelete
        },
        "editor/FileUpload": {
            req: ReqFileUpload,
            res: ResFileUpload
        },
        "editor/GetAdRevenueConfigs": {
            req: ReqGetAdRevenueConfigs,
            res: ResGetAdRevenueConfigs
        },
        "editor/GetAdRevenueReportRecords": {
            req: ReqGetAdRevenueReportRecords,
            res: ResGetAdRevenueReportRecords
        },
        "editor/GetCurrentUser": {
            req: ReqGetCurrentUser,
            res: ResGetCurrentUser
        },
        "editor/GetManagedUsers": {
            req: ReqGetManagedUsers,
            res: ResGetManagedUsers
        },
        "editor/GetTencentAdsRetentionOverview": {
            req: ReqGetTencentAdsRetentionOverview,
            res: ResGetTencentAdsRetentionOverview
        },
        "editor/GetTencentAdsRetentionReports": {
            req: ReqGetTencentAdsRetentionReports,
            res: ResGetTencentAdsRetentionReports
        },
        "editor/RetryAdRevenueReports": {
            req: ReqRetryAdRevenueReports,
            res: ResRetryAdRevenueReports
        },
        "editor/RetryTencentAdsRetentionReports": {
            req: ReqRetryTencentAdsRetentionReports,
            res: ResRetryTencentAdsRetentionReports
        },
        "editor/SaveAdRevenueConfig": {
            req: ReqSaveAdRevenueConfig,
            res: ResSaveAdRevenueConfig
        },
        "editor/SaveTencentAdsRetentionConfig": {
            req: ReqSaveTencentAdsRetentionConfig,
            res: ResSaveTencentAdsRetentionConfig
        },
        "editor/UpdateManagedUser": {
            req: ReqUpdateManagedUser,
            res: ResUpdateManagedUser
        },
        "editor/UploadAssetBundle": {
            req: ReqUploadAssetBundle,
            res: ResUploadAssetBundle
        },
        "LoginWithToken": {
            req: ReqLoginWithToken,
            res: ResLoginWithToken
        },
        "LoginWithUsername": {
            req: ReqLoginWithUsername,
            res: ResLoginWithUsername
        },
        "Register": {
            req: ReqRegister,
            res: ResRegister
        }
    },
    msg: {

    }
}

export const serviceProto: ServiceProto<ServiceType> = {
    "version": 14,
    "services": [
        {
            "id": 11,
            "name": "editor/AnalyticsQuery",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin"
                ]
            }
        },
        {
            "id": 12,
            "name": "editor/CommercialAnalyticsQuery",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin"
                ]
            }
        },
        {
            "id": 0,
            "name": "editor/DataDelete",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin"
                ]
            }
        },
        {
            "id": 1,
            "name": "editor/DataDistinct",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin"
                ]
            }
        },
        {
            "id": 2,
            "name": "editor/DataFind",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin"
                ]
            }
        },
        {
            "id": 3,
            "name": "editor/DataInsert",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin"
                ]
            }
        },
        {
            "id": 4,
            "name": "editor/DataUpdate",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin"
                ]
            }
        },
        {
            "id": 16,
            "name": "editor/DisableAdRevenueConfig",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin",
                    "superadmin"
                ]
            }
        },
        {
            "id": 5,
            "name": "editor/FileDelete",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin"
                ]
            }
        },
        {
            "id": 6,
            "name": "editor/FileUpload",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin"
                ]
            }
        },
        {
            "id": 17,
            "name": "editor/GetAdRevenueConfigs",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin",
                    "superadmin"
                ]
            }
        },
        {
            "id": 18,
            "name": "editor/GetAdRevenueReportRecords",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin",
                    "superadmin"
                ]
            }
        },
        {
            "id": 13,
            "name": "editor/GetCurrentUser",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "player",
                    "gm",
                    "admin",
                    "superadmin"
                ]
            }
        },
        {
            "id": 14,
            "name": "editor/GetManagedUsers",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "superadmin"
                ]
            }
        },
        {
            "id": 21,
            "name": "editor/GetTencentAdsRetentionOverview",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin",
                    "superadmin"
                ]
            }
        },
        {
            "id": 22,
            "name": "editor/GetTencentAdsRetentionReports",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin",
                    "superadmin"
                ]
            }
        },
        {
            "id": 19,
            "name": "editor/RetryAdRevenueReports",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin",
                    "superadmin"
                ]
            }
        },
        {
            "id": 23,
            "name": "editor/RetryTencentAdsRetentionReports",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin",
                    "superadmin"
                ]
            }
        },
        {
            "id": 20,
            "name": "editor/SaveAdRevenueConfig",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin",
                    "superadmin"
                ]
            }
        },
        {
            "id": 24,
            "name": "editor/SaveTencentAdsRetentionConfig",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin",
                    "superadmin"
                ]
            }
        },
        {
            "id": 15,
            "name": "editor/UpdateManagedUser",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "superadmin"
                ]
            }
        },
        {
            "id": 7,
            "name": "editor/UploadAssetBundle",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": [
                    "admin"
                ]
            }
        },
        {
            "id": 8,
            "name": "LoginWithToken",
            "type": "api",
            "conf": {
                "needLogin": true,
                "needRoles": []
            }
        },
        {
            "id": 9,
            "name": "LoginWithUsername",
            "type": "api",
            "conf": {
                "needLogin": false,
                "needRoles": []
            }
        },
        {
            "id": 10,
            "name": "Register",
            "type": "api",
            "conf": {
                "needLogin": false,
                "needRoles": []
            }
        }
    ],
    "types": {
        "editor/PtlAnalyticsQuery/ReqAnalyticsQuery": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "kind",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "overview"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "funnel"
                                }
                            },
                            {
                                "id": 2,
                                "type": {
                                    "type": "Literal",
                                    "literal": "taskStats"
                                }
                            },
                            {
                                "id": 3,
                                "type": {
                                    "type": "Literal",
                                    "literal": "propStats"
                                }
                            },
                            {
                                "id": 5,
                                "type": {
                                    "type": "Literal",
                                    "literal": "roundStats"
                                }
                            },
                            {
                                "id": 6,
                                "type": {
                                    "type": "Literal",
                                    "literal": "effectStats"
                                }
                            },
                            {
                                "id": 7,
                                "type": {
                                    "type": "Literal",
                                    "literal": "choiceStats"
                                }
                            },
                            {
                                "id": 8,
                                "type": {
                                    "type": "Literal",
                                    "literal": "retention"
                                }
                            },
                            {
                                "id": 4,
                                "type": {
                                    "type": "Literal",
                                    "literal": "sessions"
                                }
                            }
                        ]
                    }
                },
                {
                    "id": 1,
                    "name": "startTime",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "endTime",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "platform",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "appVersion",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "resourceVersion",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 6,
                    "name": "grade",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 7,
                    "name": "level",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 8,
                    "name": "taskIndex",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 9,
                    "name": "potionId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 10,
                    "name": "propId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 11,
                    "name": "steps",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "String"
                        }
                    },
                    "optional": true
                },
                {
                    "id": 12,
                    "name": "limit",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 13,
                    "name": "skip",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                }
            ]
        },
        "base/BaseRequest": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "timestamp",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 1,
                    "name": "token",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "characterId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "version",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "platform",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Reference",
                                    "target": "../types/enums/Platform"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "String"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "data",
                    "type": {
                        "type": "Any"
                    },
                    "optional": true
                }
            ]
        },
        "../types/enums/Platform": {
            "type": "Enum",
            "members": [
                {
                    "id": 4,
                    "value": "EDITOR_PAGE"
                },
                {
                    "id": 5,
                    "value": "DESKTOP_BROWSER"
                },
                {
                    "id": 6,
                    "value": "WECHAT_GAME"
                },
                {
                    "id": 7,
                    "value": "BYTEDANCE_MINI_GAME"
                }
            ]
        },
        "editor/PtlAnalyticsQuery/ResAnalyticsQuery": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Any"
                    }
                }
            ]
        },
        "base/BaseResponse": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "timestamp",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 1,
                    "name": "data",
                    "type": {
                        "type": "Any"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/ReqCommercialAnalyticsQuery": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "scope",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlCommercialAnalyticsQuery/CommercialAnalyticsScope"
                    }
                },
                {
                    "id": 1,
                    "name": "kind",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlCommercialAnalyticsQuery/CommercialAnalyticsKind"
                    }
                },
                {
                    "id": 2,
                    "name": "startTime",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "endTime",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "platform",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "userId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 6,
                    "name": "page",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 7,
                    "name": "pageSize",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 8,
                    "name": "sortField",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 9,
                    "name": "sortOrder",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "asc"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "desc"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 18,
                    "name": "provider",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "ocean_engine"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "tencent_ads"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 10,
                    "name": "channel",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "clickid"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "clue_token"
                                }
                            },
                            {
                                "id": 3,
                                "type": {
                                    "type": "Literal",
                                    "literal": "gdt_vid"
                                }
                            },
                            {
                                "id": 4,
                                "type": {
                                    "type": "Literal",
                                    "literal": "tencent_click_id"
                                }
                            },
                            {
                                "id": 5,
                                "type": {
                                    "type": "Literal",
                                    "literal": "wechat_identity"
                                }
                            },
                            {
                                "id": 2,
                                "type": {
                                    "type": "Literal",
                                    "literal": "none"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 11,
                    "name": "status",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "pending"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "reporting"
                                }
                            },
                            {
                                "id": 2,
                                "type": {
                                    "type": "Literal",
                                    "literal": "succeeded"
                                }
                            },
                            {
                                "id": 3,
                                "type": {
                                    "type": "Literal",
                                    "literal": "failed"
                                }
                            },
                            {
                                "id": 4,
                                "type": {
                                    "type": "Literal",
                                    "literal": "skipped"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 12,
                    "name": "providerCode",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "String"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 13,
                    "name": "adType",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 14,
                    "name": "adUnitId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 19,
                    "name": "adPlacementName",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 15,
                    "name": "success",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                },
                {
                    "id": 16,
                    "name": "isEnded",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                },
                {
                    "id": 17,
                    "name": "errCode",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "String"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 20,
                    "name": "exportType",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlCommercialAnalyticsQuery/AdUserOpenIdExportType"
                    },
                    "optional": true
                },
                {
                    "id": 21,
                    "name": "exportRules",
                    "type": {
                        "type": "Partial",
                        "target": {
                            "type": "Reference",
                            "target": "editor/PtlCommercialAnalyticsQuery/AdUserOpenIdExportRules"
                        }
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/CommercialAnalyticsScope": {
            "type": "Union",
            "members": [
                {
                    "id": 0,
                    "type": {
                        "type": "Literal",
                        "literal": "activation"
                    }
                },
                {
                    "id": 1,
                    "type": {
                        "type": "Literal",
                        "literal": "adPlay"
                    }
                },
                {
                    "id": 2,
                    "type": {
                        "type": "Literal",
                        "literal": "adUserOpenIdExport"
                    }
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/CommercialAnalyticsKind": {
            "type": "Union",
            "members": [
                {
                    "id": 0,
                    "type": {
                        "type": "Literal",
                        "literal": "summary"
                    }
                },
                {
                    "id": 1,
                    "type": {
                        "type": "Literal",
                        "literal": "records"
                    }
                },
                {
                    "id": 2,
                    "type": {
                        "type": "Literal",
                        "literal": "exportOpenIds"
                    }
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/AdUserOpenIdExportType": {
            "type": "Union",
            "members": [
                {
                    "id": 0,
                    "type": {
                        "type": "Literal",
                        "literal": "lowQuality"
                    }
                },
                {
                    "id": 1,
                    "type": {
                        "type": "Literal",
                        "literal": "highQuality"
                    }
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/AdUserOpenIdExportRules": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "lowQuality",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlCommercialAnalyticsQuery/AdUserOpenIdExportRule"
                    }
                },
                {
                    "id": 1,
                    "name": "highQuality",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlCommercialAnalyticsQuery/AdUserOpenIdExportRule"
                    }
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/AdUserOpenIdExportRule": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "rewardedCompleted",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlCommercialAnalyticsQuery/AdUserOpenIdExportCondition"
                    }
                },
                {
                    "id": 1,
                    "name": "interstitialCompleted",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlCommercialAnalyticsQuery/AdUserOpenIdExportCondition"
                    }
                },
                {
                    "id": 2,
                    "name": "relation",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "and"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "or"
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/AdUserOpenIdExportCondition": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "operator",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlCommercialAnalyticsQuery/ComparisonOperator"
                    }
                },
                {
                    "id": 1,
                    "name": "value",
                    "type": {
                        "type": "Number"
                    }
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/ComparisonOperator": {
            "type": "Union",
            "members": [
                {
                    "id": 0,
                    "type": {
                        "type": "Literal",
                        "literal": "eq"
                    }
                },
                {
                    "id": 1,
                    "type": {
                        "type": "Literal",
                        "literal": "lt"
                    }
                },
                {
                    "id": 2,
                    "type": {
                        "type": "Literal",
                        "literal": "lte"
                    }
                },
                {
                    "id": 3,
                    "type": {
                        "type": "Literal",
                        "literal": "gt"
                    }
                },
                {
                    "id": 4,
                    "type": {
                        "type": "Literal",
                        "literal": "gte"
                    }
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/ResCommercialAnalyticsQuery": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Reference",
                                    "target": "editor/PtlCommercialAnalyticsQuery/ActivationSummaryData"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Reference",
                                    "target": "editor/PtlCommercialAnalyticsQuery/AdPlaySummaryData"
                                }
                            },
                            {
                                "id": 2,
                                "type": {
                                    "type": "Reference",
                                    "target": "editor/PtlCommercialAnalyticsQuery/CommercialRecordsData"
                                }
                            },
                            {
                                "id": 3,
                                "type": {
                                    "type": "Reference",
                                    "target": "editor/PtlCommercialAnalyticsQuery/AdUserOpenIdExportData"
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/ActivationSummaryData": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "scope",
                    "type": {
                        "type": "Literal",
                        "literal": "activation"
                    }
                },
                {
                    "id": 1,
                    "name": "range",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlCommercialAnalyticsQuery/CommercialAnalyticsRange"
                    }
                },
                {
                    "id": 2,
                    "name": "kpis",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "recordCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 1,
                                "name": "userCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 2,
                                "name": "attributedUserCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 3,
                                "name": "attributedTaskCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 4,
                                "name": "succeededUserCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 5,
                                "name": "succeededCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 6,
                                "name": "failedCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 7,
                                "name": "pendingCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 8,
                                "name": "reportingCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 9,
                                "name": "skippedCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 10,
                                "name": "attributionRate",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 11,
                                "name": "successRate",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 12,
                                "name": "averageAttempts",
                                "type": {
                                    "type": "Number"
                                }
                            }
                        ]
                    }
                },
                {
                    "id": 3,
                    "name": "trends",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlCommercialAnalyticsQuery/CommercialTrendRow"
                        }
                    }
                },
                {
                    "id": 10,
                    "name": "providers",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlCommercialAnalyticsQuery/CommercialDimensionRow"
                        }
                    }
                },
                {
                    "id": 4,
                    "name": "channels",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlCommercialAnalyticsQuery/CommercialDimensionRow"
                        }
                    }
                },
                {
                    "id": 5,
                    "name": "statuses",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlCommercialAnalyticsQuery/CommercialDimensionRow"
                        }
                    }
                },
                {
                    "id": 6,
                    "name": "platforms",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlCommercialAnalyticsQuery/CommercialDimensionRow"
                        }
                    }
                },
                {
                    "id": 7,
                    "name": "providerCodes",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlCommercialAnalyticsQuery/CommercialDimensionRow"
                        }
                    }
                },
                {
                    "id": 8,
                    "name": "failureReasons",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Interface",
                            "properties": [
                                {
                                    "id": 0,
                                    "name": "key",
                                    "type": {
                                        "type": "String"
                                    }
                                },
                                {
                                    "id": 1,
                                    "name": "count",
                                    "type": {
                                        "type": "Number"
                                    }
                                },
                                {
                                    "id": 2,
                                    "name": "userCount",
                                    "type": {
                                        "type": "Number"
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    "id": 9,
                    "name": "options",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 4,
                                "name": "providers",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "String"
                                    }
                                }
                            },
                            {
                                "id": 0,
                                "name": "channels",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "String"
                                    }
                                }
                            },
                            {
                                "id": 1,
                                "name": "statuses",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "String"
                                    }
                                }
                            },
                            {
                                "id": 2,
                                "name": "platforms",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "String"
                                    }
                                }
                            },
                            {
                                "id": 3,
                                "name": "providerCodes",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Union",
                                        "members": [
                                            {
                                                "id": 0,
                                                "type": {
                                                    "type": "Number"
                                                }
                                            },
                                            {
                                                "id": 1,
                                                "type": {
                                                    "type": "String"
                                                }
                                            }
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/CommercialAnalyticsRange": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "startTime",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 1,
                    "name": "endTime",
                    "type": {
                        "type": "Number"
                    }
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/CommercialTrendRow": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "bucket",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "count",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 2,
                    "name": "userCount",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 3,
                    "name": "successCount",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 4,
                    "name": "failedCount",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 5,
                    "name": "attributedUserCount",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 6,
                    "name": "endedCount",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 7,
                    "name": "rewardedVideoCount",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 8,
                    "name": "interstitialCount",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/CommercialDimensionRow": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "key",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "count",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 2,
                    "name": "userCount",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 3,
                    "name": "successCount",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 4,
                    "name": "failedCount",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 5,
                    "name": "successRate",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 6,
                    "name": "endedCount",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 7,
                    "name": "endedKnownCount",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 8,
                    "name": "completionRate",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 9,
                    "name": "averageDurationMs",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/AdPlaySummaryData": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "scope",
                    "type": {
                        "type": "Literal",
                        "literal": "adPlay"
                    }
                },
                {
                    "id": 1,
                    "name": "range",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlCommercialAnalyticsQuery/CommercialAnalyticsRange"
                    }
                },
                {
                    "id": 2,
                    "name": "kpis",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "recordCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 1,
                                "name": "userCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 2,
                                "name": "succeededCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 3,
                                "name": "failedCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 4,
                                "name": "successRate",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 5,
                                "name": "endedCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 6,
                                "name": "endedKnownCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 7,
                                "name": "completionRate",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 8,
                                "name": "averageDurationMs",
                                "type": {
                                    "type": "Number"
                                }
                            }
                        ]
                    }
                },
                {
                    "id": 3,
                    "name": "trends",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlCommercialAnalyticsQuery/CommercialTrendRow"
                        }
                    }
                },
                {
                    "id": 4,
                    "name": "adTypes",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlCommercialAnalyticsQuery/CommercialDimensionRow"
                        }
                    }
                },
                {
                    "id": 9,
                    "name": "adPlacements",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlCommercialAnalyticsQuery/CommercialDimensionRow"
                        }
                    }
                },
                {
                    "id": 5,
                    "name": "adUnits",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlCommercialAnalyticsQuery/CommercialDimensionRow"
                        }
                    }
                },
                {
                    "id": 6,
                    "name": "platforms",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlCommercialAnalyticsQuery/CommercialDimensionRow"
                        }
                    }
                },
                {
                    "id": 7,
                    "name": "errors",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Interface",
                            "properties": [
                                {
                                    "id": 0,
                                    "name": "key",
                                    "type": {
                                        "type": "String"
                                    }
                                },
                                {
                                    "id": 1,
                                    "name": "errCode",
                                    "type": {
                                        "type": "Union",
                                        "members": [
                                            {
                                                "id": 0,
                                                "type": {
                                                    "type": "Number"
                                                }
                                            },
                                            {
                                                "id": 1,
                                                "type": {
                                                    "type": "String"
                                                }
                                            }
                                        ]
                                    },
                                    "optional": true
                                },
                                {
                                    "id": 2,
                                    "name": "errMsg",
                                    "type": {
                                        "type": "String"
                                    },
                                    "optional": true
                                },
                                {
                                    "id": 3,
                                    "name": "adType",
                                    "type": {
                                        "type": "String"
                                    },
                                    "optional": true
                                },
                                {
                                    "id": 4,
                                    "name": "count",
                                    "type": {
                                        "type": "Number"
                                    }
                                },
                                {
                                    "id": 5,
                                    "name": "userCount",
                                    "type": {
                                        "type": "Number"
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    "id": 8,
                    "name": "options",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "adTypes",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "String"
                                    }
                                }
                            },
                            {
                                "id": 4,
                                "name": "adPlacements",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "String"
                                    }
                                }
                            },
                            {
                                "id": 1,
                                "name": "adUnits",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "String"
                                    }
                                }
                            },
                            {
                                "id": 2,
                                "name": "platforms",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "String"
                                    }
                                }
                            },
                            {
                                "id": 3,
                                "name": "errCodes",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Union",
                                        "members": [
                                            {
                                                "id": 0,
                                                "type": {
                                                    "type": "Number"
                                                }
                                            },
                                            {
                                                "id": 1,
                                                "type": {
                                                    "type": "String"
                                                }
                                            }
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/CommercialRecordsData": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "scope",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlCommercialAnalyticsQuery/CommercialAnalyticsScope"
                    }
                },
                {
                    "id": 1,
                    "name": "range",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlCommercialAnalyticsQuery/CommercialAnalyticsRange"
                    }
                },
                {
                    "id": 2,
                    "name": "total",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 3,
                    "name": "page",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 4,
                    "name": "pageSize",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 5,
                    "name": "rows",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Reference",
                                        "target": "editor/PtlCommercialAnalyticsQuery/ActivationRecordRow"
                                    }
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Reference",
                                        "target": "editor/PtlCommercialAnalyticsQuery/AdPlayRecordRow"
                                    }
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/ActivationRecordRow": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "_id",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "userId",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 2,
                    "name": "username",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "nickname",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "platform",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 19,
                    "name": "provider",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 20,
                    "name": "actionType",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "channel",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 6,
                    "name": "status",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 7,
                    "name": "attempts",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 8,
                    "name": "createdAt",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 9,
                    "name": "updatedAt",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 10,
                    "name": "lastAttemptAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 11,
                    "name": "reportedAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 12,
                    "name": "attributionValueHash",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 13,
                    "name": "providerHttpStatus",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 14,
                    "name": "providerCode",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "String"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 15,
                    "name": "providerMessage",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 16,
                    "name": "lastError",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 17,
                    "name": "skipReason",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 18,
                    "name": "source",
                    "type": {
                        "type": "Any"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/AdPlayRecordRow": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "_id",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "userId",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 2,
                    "name": "username",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "nickname",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "characterId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "platform",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 6,
                    "name": "clientVersion",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 7,
                    "name": "adType",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 8,
                    "name": "adUnitId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 18,
                    "name": "adPlacementName",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 9,
                    "name": "success",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 10,
                    "name": "isEnded",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                },
                {
                    "id": 11,
                    "name": "errCode",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "String"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 12,
                    "name": "errMsg",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 13,
                    "name": "durationMs",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 14,
                    "name": "clientTime",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 15,
                    "name": "serverTime",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 16,
                    "name": "receivedAt",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 17,
                    "name": "extra",
                    "type": {
                        "type": "Any"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlCommercialAnalyticsQuery/AdUserOpenIdExportData": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "scope",
                    "type": {
                        "type": "Literal",
                        "literal": "adUserOpenIdExport"
                    }
                },
                {
                    "id": 1,
                    "name": "exportType",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlCommercialAnalyticsQuery/AdUserOpenIdExportType"
                    }
                },
                {
                    "id": 2,
                    "name": "filename",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 3,
                    "name": "count",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 4,
                    "name": "csv",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 5,
                    "name": "rules",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlCommercialAnalyticsQuery/AdUserOpenIdExportRules"
                    }
                }
            ]
        },
        "editor/PtlDataDelete/ReqDataDelete": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "collection",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "filter",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlDataFind/Filter"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "multi",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlDataFind/Filter": {
            "type": "Interface",
            "indexSignature": {
                "keyType": "String",
                "type": {
                    "type": "Union",
                    "members": [
                        {
                            "id": 0,
                            "type": {
                                "type": "Reference",
                                "target": "editor/PtlDataFind/Operator"
                            }
                        },
                        {
                            "id": 1,
                            "type": {
                                "type": "Reference",
                                "target": "editor/PtlDataFind/Primitive"
                            }
                        },
                        {
                            "id": 2,
                            "type": {
                                "type": "Array",
                                "elementType": {
                                    "type": "Reference",
                                    "target": "editor/PtlDataFind/Primitive"
                                }
                            }
                        },
                        {
                            "id": 3,
                            "type": {
                                "type": "Object"
                            }
                        }
                    ]
                }
            }
        },
        "editor/PtlDataFind/Operator": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "$eq",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlDataFind/Primitive"
                    },
                    "optional": true
                },
                {
                    "id": 1,
                    "name": "$ne",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlDataFind/Primitive"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "$gt",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlDataFind/Primitive"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "$gte",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlDataFind/Primitive"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "$lt",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlDataFind/Primitive"
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "$lte",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlDataFind/Primitive"
                    },
                    "optional": true
                },
                {
                    "id": 6,
                    "name": "$in",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlDataFind/Primitive"
                        }
                    },
                    "optional": true
                },
                {
                    "id": 7,
                    "name": "$nin",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlDataFind/Primitive"
                        }
                    },
                    "optional": true
                },
                {
                    "id": 8,
                    "name": "$regex",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 9,
                    "name": "$and",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlDataFind/Filter"
                        }
                    },
                    "optional": true
                },
                {
                    "id": 10,
                    "name": "$or",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlDataFind/Filter"
                        }
                    },
                    "optional": true
                },
                {
                    "id": 11,
                    "name": "$nor",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "editor/PtlDataFind/Filter"
                        }
                    },
                    "optional": true
                },
                {
                    "id": 12,
                    "name": "$text",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlDataFind/TextOperator"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlDataFind/Primitive": {
            "type": "Union",
            "members": [
                {
                    "id": 0,
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 2,
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 3,
                    "type": {
                        "type": "Date"
                    }
                },
                {
                    "id": 4,
                    "type": {
                        "type": "Literal"
                    }
                },
                {
                    "id": 5,
                    "type": {
                        "type": "Literal",
                        "literal": null
                    }
                }
            ]
        },
        "editor/PtlDataFind/TextOperator": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "$search",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "$caseSensitive",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "$diacriticSensitive",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "$language",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlDataDelete/ResDataDelete": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "deletedCount",
                    "type": {
                        "type": "Number"
                    }
                }
            ]
        },
        "editor/PtlDataDistinct/ReqDataDistinct": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "collection",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "field",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 2,
                    "name": "query",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlDataFind/Filter"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "options",
                    "type": {
                        "type": "Any"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlDataDistinct/ResDataDistinct": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Any"
                        }
                    }
                }
            ]
        },
        "editor/PtlDataFind/ReqDataFind": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "collection",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "filter",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlDataFind/Filter"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "sort",
                    "type": {
                        "type": "Interface",
                        "indexSignature": {
                            "keyType": "String",
                            "type": {
                                "type": "Reference",
                                "target": "editor/PtlDataFind/SortOrder"
                            }
                        }
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "skip",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "limit",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "projection",
                    "type": {
                        "type": "Interface",
                        "indexSignature": {
                            "keyType": "String",
                            "type": {
                                "type": "Union",
                                "members": [
                                    {
                                        "id": 0,
                                        "type": {
                                            "type": "Literal",
                                            "literal": 0
                                        }
                                    },
                                    {
                                        "id": 1,
                                        "type": {
                                            "type": "Literal",
                                            "literal": 1
                                        }
                                    }
                                ]
                            }
                        }
                    },
                    "optional": true
                },
                {
                    "id": 6,
                    "name": "random",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlDataFind/SortOrder": {
            "type": "Enum",
            "members": [
                {
                    "id": 0,
                    "value": 1
                },
                {
                    "id": 1,
                    "value": -1
                }
            ]
        },
        "editor/PtlDataFind/ResDataFind": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Any"
                        }
                    }
                }
            ]
        },
        "editor/PtlDataInsert/ReqDataInsert": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "collection",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "data",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Any"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Any"
                                    }
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "editor/PtlDataInsert/ResDataInsert": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "insertedCount",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 1,
                    "name": "insertedIds",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "String"
                        }
                    }
                }
            ]
        },
        "editor/PtlDataUpdate/ReqDataUpdate": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "collection",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "filter",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlDataFind/Filter"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "update",
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlDataUpdate/UpdateData"
                    }
                },
                {
                    "id": 3,
                    "name": "multi",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlDataUpdate/UpdateData": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "$set",
                    "type": {
                        "type": "Interface",
                        "indexSignature": {
                            "keyType": "String",
                            "type": {
                                "type": "Reference",
                                "target": "editor/PtlDataUpdate/UpdateValue"
                            }
                        }
                    },
                    "optional": true
                },
                {
                    "id": 1,
                    "name": "$unset",
                    "type": {
                        "type": "Interface",
                        "indexSignature": {
                            "keyType": "String",
                            "type": {
                                "type": "Union",
                                "members": [
                                    {
                                        "id": 0,
                                        "type": {
                                            "type": "Literal",
                                            "literal": ""
                                        }
                                    },
                                    {
                                        "id": 1,
                                        "type": {
                                            "type": "Literal",
                                            "literal": 1
                                        }
                                    }
                                ]
                            }
                        }
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "$inc",
                    "type": {
                        "type": "Interface",
                        "indexSignature": {
                            "keyType": "String",
                            "type": {
                                "type": "Number"
                            }
                        }
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "$push",
                    "type": {
                        "type": "Interface",
                        "indexSignature": {
                            "keyType": "String",
                            "type": {
                                "type": "Reference",
                                "target": "editor/PtlDataUpdate/UpdateValue"
                            }
                        }
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "$pull",
                    "type": {
                        "type": "Interface",
                        "indexSignature": {
                            "keyType": "String",
                            "type": {
                                "type": "Reference",
                                "target": "editor/PtlDataUpdate/UpdateValue"
                            }
                        }
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "$addToSet",
                    "type": {
                        "type": "Interface",
                        "indexSignature": {
                            "keyType": "String",
                            "type": {
                                "type": "Reference",
                                "target": "editor/PtlDataUpdate/UpdateValue"
                            }
                        }
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlDataUpdate/UpdateValue": {
            "type": "Union",
            "members": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "editor/PtlDataFind/Primitive"
                    }
                },
                {
                    "id": 1,
                    "type": {
                        "type": "Object"
                    }
                },
                {
                    "id": 2,
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Union",
                            "members": [
                                {
                                    "id": 0,
                                    "type": {
                                        "type": "Reference",
                                        "target": "editor/PtlDataFind/Primitive"
                                    }
                                },
                                {
                                    "id": 1,
                                    "type": {
                                        "type": "Object"
                                    }
                                }
                            ]
                        }
                    }
                }
            ]
        },
        "editor/PtlDataUpdate/ResDataUpdate": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "matchedCount",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 1,
                    "name": "modifiedCount",
                    "type": {
                        "type": "Number"
                    }
                }
            ]
        },
        "editor/PtlDisableAdRevenueConfig/ReqDisableAdRevenueConfig": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "configId",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "expectedRevision",
                    "type": {
                        "type": "Number"
                    }
                }
            ]
        },
        "editor/PtlDisableAdRevenueConfig/ResDisableAdRevenueConfig": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "status",
                                "type": {
                                    "type": "Union",
                                    "members": [
                                        {
                                            "id": 0,
                                            "type": {
                                                "type": "Literal",
                                                "literal": "disabled"
                                            }
                                        },
                                        {
                                            "id": 1,
                                            "type": {
                                                "type": "Literal",
                                                "literal": "revision_conflict"
                                            }
                                        },
                                        {
                                            "id": 2,
                                            "type": {
                                                "type": "Literal",
                                                "literal": "not_found"
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                "id": 1,
                                "name": "current",
                                "type": {
                                    "type": "Reference",
                                    "target": "../types/AdRevenueManagement/AdRevenueConfigRow"
                                },
                                "optional": true
                            },
                            {
                                "id": 2,
                                "name": "configVersion",
                                "type": {
                                    "type": "Number"
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "../types/AdRevenueManagement/AdRevenueConfigRow": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "id",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "scope",
                    "type": {
                        "type": "Reference",
                        "target": "../types/AdRevenueManagement/AdRevenueConfigScope"
                    }
                },
                {
                    "id": 2,
                    "name": "adType",
                    "type": {
                        "type": "Reference",
                        "target": "../types/AdRevenueManagement/AdRevenueAdType"
                    }
                },
                {
                    "id": 3,
                    "name": "adUnitId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "adPlacementName",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "revenueCent",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 6,
                    "name": "effectiveFrom",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 7,
                    "name": "effectiveTo",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 8,
                    "name": "enabled",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 15,
                    "name": "logicalRevision",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 9,
                    "name": "revision",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 10,
                    "name": "createdBy",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 11,
                    "name": "updatedBy",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 12,
                    "name": "createdAt",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 13,
                    "name": "updatedAt",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 14,
                    "name": "isCurrent",
                    "type": {
                        "type": "Boolean"
                    }
                }
            ]
        },
        "../types/AdRevenueManagement/AdRevenueConfigScope": {
            "type": "Union",
            "members": [
                {
                    "id": 0,
                    "type": {
                        "type": "Literal",
                        "literal": "ad_unit"
                    }
                },
                {
                    "id": 1,
                    "type": {
                        "type": "Literal",
                        "literal": "ad_type"
                    }
                }
            ]
        },
        "../types/AdRevenueManagement/AdRevenueAdType": {
            "type": "Union",
            "members": [
                {
                    "id": 0,
                    "type": {
                        "type": "Literal",
                        "literal": "rewardedVideo"
                    }
                },
                {
                    "id": 1,
                    "type": {
                        "type": "Literal",
                        "literal": "interstitial"
                    }
                }
            ]
        },
        "editor/PtlFileDelete/ReqFileDelete": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "path",
                    "type": {
                        "type": "String"
                    }
                }
            ]
        },
        "editor/PtlFileDelete/ResFileDelete": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ]
        },
        "editor/PtlFileUpload/ReqFileUpload": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "path",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "ext",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 2,
                    "name": "data",
                    "type": {
                        "type": "Buffer",
                        "arrayType": "Uint8Array"
                    }
                }
            ]
        },
        "editor/PtlFileUpload/ResFileUpload": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "md5",
                    "type": {
                        "type": "String"
                    }
                }
            ]
        },
        "editor/PtlGetAdRevenueConfigs/ReqGetAdRevenueConfigs": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "scope",
                    "type": {
                        "type": "Reference",
                        "target": "../types/AdRevenueManagement/AdRevenueConfigScope"
                    },
                    "optional": true
                },
                {
                    "id": 1,
                    "name": "adType",
                    "type": {
                        "type": "Reference",
                        "target": "../types/AdRevenueManagement/AdRevenueAdType"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "includeHistory",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "historyLimit",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "includeCandidates",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlGetAdRevenueConfigs/ResGetAdRevenueConfigs": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "current",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Reference",
                                        "target": "../types/AdRevenueManagement/AdRevenueConfigRow"
                                    }
                                }
                            },
                            {
                                "id": 1,
                                "name": "history",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Reference",
                                        "target": "../types/AdRevenueManagement/AdRevenueConfigRow"
                                    }
                                }
                            },
                            {
                                "id": 2,
                                "name": "candidates",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Reference",
                                        "target": "../types/AdRevenueManagement/AdRevenueUnconfiguredCandidate"
                                    }
                                }
                            },
                            {
                                "id": 3,
                                "name": "runtime",
                                "type": {
                                    "type": "Reference",
                                    "target": "../types/AdRevenueManagement/AdRevenueRuntimeStatus"
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "../types/AdRevenueManagement/AdRevenueUnconfiguredCandidate": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "adType",
                    "type": {
                        "type": "Reference",
                        "target": "../types/AdRevenueManagement/AdRevenueAdType"
                    }
                },
                {
                    "id": 1,
                    "name": "adUnitId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "adPlacementName",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "waitingCount",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 4,
                    "name": "oldestWaitingAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "newestWaitingAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                }
            ]
        },
        "../types/AdRevenueManagement/AdRevenueRuntimeStatus": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "configVersion",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 1,
                    "name": "mode",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "off"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "capture"
                                }
                            },
                            {
                                "id": 2,
                                "type": {
                                    "type": "Literal",
                                    "literal": "live"
                                }
                            },
                            {
                                "id": 3,
                                "type": {
                                    "type": "Literal",
                                    "literal": "unknown"
                                }
                            }
                        ]
                    }
                },
                {
                    "id": 2,
                    "name": "workerEnabled",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "workerHealthy",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "workerHeartbeatAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "lastConfigReloadAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 6,
                    "name": "lastAttemptAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 7,
                    "name": "lastSucceededAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 8,
                    "name": "queue",
                    "type": {
                        "type": "Reference",
                        "target": "../types/AdRevenueManagement/AdRevenueRuntimeQueueStats"
                    }
                }
            ]
        },
        "../types/AdRevenueManagement/AdRevenueRuntimeQueueStats": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "waitingConfig",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 1,
                    "name": "pending",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 2,
                    "name": "captured",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 3,
                    "name": "reporting",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 4,
                    "name": "failed",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 5,
                    "name": "skipped",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 6,
                    "name": "succeeded",
                    "type": {
                        "type": "Number"
                    }
                }
            ]
        },
        "editor/PtlGetAdRevenueReportRecords/ReqGetAdRevenueReportRecords": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "page",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 1,
                    "name": "pageSize",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "startTime",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "endTime",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "statuses",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "../types/AdRevenueManagement/AdRevenueReportStatus"
                        }
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "adType",
                    "type": {
                        "type": "Reference",
                        "target": "../types/AdRevenueManagement/AdRevenueAdType"
                    },
                    "optional": true
                },
                {
                    "id": 6,
                    "name": "adUnitId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 7,
                    "name": "adPlacementName",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 8,
                    "name": "userId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 9,
                    "name": "providerCode",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "String"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 10,
                    "name": "sortOrder",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "asc"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "desc"
                                }
                            }
                        ]
                    },
                    "optional": true
                }
            ]
        },
        "../types/AdRevenueManagement/AdRevenueReportStatus": {
            "type": "Union",
            "members": [
                {
                    "id": 0,
                    "type": {
                        "type": "Literal",
                        "literal": "waiting_config"
                    }
                },
                {
                    "id": 1,
                    "type": {
                        "type": "Literal",
                        "literal": "pending"
                    }
                },
                {
                    "id": 2,
                    "type": {
                        "type": "Literal",
                        "literal": "captured"
                    }
                },
                {
                    "id": 3,
                    "type": {
                        "type": "Literal",
                        "literal": "reporting"
                    }
                },
                {
                    "id": 4,
                    "type": {
                        "type": "Literal",
                        "literal": "succeeded"
                    }
                },
                {
                    "id": 5,
                    "type": {
                        "type": "Literal",
                        "literal": "failed"
                    }
                },
                {
                    "id": 6,
                    "type": {
                        "type": "Literal",
                        "literal": "skipped"
                    }
                }
            ]
        },
        "editor/PtlGetAdRevenueReportRecords/ResGetAdRevenueReportRecords": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "total",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 4,
                                "name": "accessibleTotal",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 5,
                                "name": "maxAccessibleRecords",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 1,
                                "name": "page",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 2,
                                "name": "pageSize",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 3,
                                "name": "rows",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Reference",
                                        "target": "../types/AdRevenueManagement/AdRevenueReportRecordRow"
                                    }
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "../types/AdRevenueManagement/AdRevenueReportRecordRow": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "id",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "sourceAdPlayReportId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "userId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "actionType",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "actionId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "actionTime",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 6,
                    "name": "adType",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 7,
                    "name": "adUnitId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 8,
                    "name": "adPlacementName",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 9,
                    "name": "revenueCent",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 10,
                    "name": "rateConfigId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 11,
                    "name": "rateRevision",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 12,
                    "name": "rateSource",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "ad_unit"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "ad_type"
                                }
                            },
                            {
                                "id": 2,
                                "type": {
                                    "type": "Literal",
                                    "literal": "none"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 13,
                    "name": "attributionChannel",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 14,
                    "name": "hasClickId",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 15,
                    "name": "status",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Reference",
                                    "target": "../types/AdRevenueManagement/AdRevenueReportStatus"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "String"
                                }
                            }
                        ]
                    }
                },
                {
                    "id": 16,
                    "name": "attempts",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 17,
                    "name": "retryable",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 18,
                    "name": "providerCode",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "String"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 19,
                    "name": "providerMessage",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 20,
                    "name": "providerTraceId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 21,
                    "name": "lastError",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 22,
                    "name": "skipReason",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 23,
                    "name": "createdAt",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 24,
                    "name": "updatedAt",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 25,
                    "name": "lastAttemptAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 26,
                    "name": "nextRetryAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 27,
                    "name": "reportedAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlGetCurrentUser/ReqGetCurrentUser": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ]
        },
        "editor/PtlGetCurrentUser/ResGetCurrentUser": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Reference",
                        "target": "../types/UserManagement/CurrentUserInfo"
                    }
                }
            ]
        },
        "../types/UserManagement/CurrentUserInfo": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "../types/UserManagement/ManagedUserSummary"
                    }
                }
            ]
        },
        "../types/UserManagement/ManagedUserSummary": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "_id",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "username",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "nickname",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "email",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "phone",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "role",
                    "type": {
                        "type": "Reference",
                        "target": "../types/UserManagement/ManagedUserRole"
                    }
                },
                {
                    "id": 6,
                    "name": "status",
                    "type": {
                        "type": "Reference",
                        "target": "../types/UserManagement/ManagedUserStatus"
                    }
                },
                {
                    "id": 7,
                    "name": "createdAt",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 8,
                    "name": "lastLoginAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                }
            ]
        },
        "../types/UserManagement/ManagedUserRole": {
            "type": "Union",
            "members": [
                {
                    "id": 0,
                    "type": {
                        "type": "Literal",
                        "literal": "player"
                    }
                },
                {
                    "id": 1,
                    "type": {
                        "type": "Literal",
                        "literal": "gm"
                    }
                },
                {
                    "id": 2,
                    "type": {
                        "type": "Literal",
                        "literal": "admin"
                    }
                },
                {
                    "id": 3,
                    "type": {
                        "type": "Literal",
                        "literal": "superadmin"
                    }
                }
            ]
        },
        "../types/UserManagement/ManagedUserStatus": {
            "type": "Union",
            "members": [
                {
                    "id": 0,
                    "type": {
                        "type": "Literal",
                        "literal": "active"
                    }
                },
                {
                    "id": 1,
                    "type": {
                        "type": "Literal",
                        "literal": "banned"
                    }
                },
                {
                    "id": 2,
                    "type": {
                        "type": "Literal",
                        "literal": "deleted"
                    }
                }
            ]
        },
        "editor/PtlGetManagedUsers/ReqGetManagedUsers": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "page",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 1,
                    "name": "pageSize",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "keyword",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "roles",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "../types/UserManagement/ManagedUserRole"
                        }
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "statuses",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "../types/UserManagement/ManagedUserStatus"
                        }
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "sortField",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "createdAt"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "lastLoginAt"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 6,
                    "name": "sortOrder",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "asc"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "desc"
                                }
                            }
                        ]
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlGetManagedUsers/ResGetManagedUsers": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "users",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Reference",
                                        "target": "../types/UserManagement/ManagedUserSummary"
                                    }
                                }
                            },
                            {
                                "id": 1,
                                "name": "total",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 2,
                                "name": "page",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 3,
                                "name": "pageSize",
                                "type": {
                                    "type": "Number"
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "editor/PtlGetTencentAdsRetentionOverview/ReqGetTencentAdsRetentionOverview": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "startTime",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 1,
                    "name": "endTime",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "auditLimit",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlGetTencentAdsRetentionOverview/ResGetTencentAdsRetentionOverview": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "config",
                                "type": {
                                    "type": "Reference",
                                    "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionConfigRow"
                                }
                            },
                            {
                                "id": 1,
                                "name": "runtime",
                                "type": {
                                    "type": "Reference",
                                    "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionRuntimeStatus"
                                }
                            },
                            {
                                "id": 2,
                                "name": "range",
                                "type": {
                                    "type": "Interface",
                                    "properties": [
                                        {
                                            "id": 0,
                                            "name": "startTime",
                                            "type": {
                                                "type": "Number"
                                            }
                                        },
                                        {
                                            "id": 1,
                                            "name": "endTime",
                                            "type": {
                                                "type": "Number"
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                "id": 3,
                                "name": "summary",
                                "type": {
                                    "type": "Reference",
                                    "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionOverviewSummary"
                                }
                            },
                            {
                                "id": 4,
                                "name": "trends",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Reference",
                                        "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionTrendRow"
                                    }
                                }
                            },
                            {
                                "id": 5,
                                "name": "recentAudits",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Reference",
                                        "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionAuditRow"
                                    }
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "../types/TencentAdsRetentionManagement/TencentAdsRetentionConfigRow": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "mode",
                    "type": {
                        "type": "Reference",
                        "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionMode"
                    }
                },
                {
                    "id": 1,
                    "name": "paused",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 2,
                    "name": "confirmed",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 3,
                    "name": "apiVersion",
                    "type": {
                        "type": "Literal",
                        "literal": "v3.0"
                    }
                },
                {
                    "id": 4,
                    "name": "timezone",
                    "type": {
                        "type": "Literal",
                        "literal": "Asia/Shanghai"
                    }
                },
                {
                    "id": 5,
                    "name": "actionType",
                    "type": {
                        "type": "Literal",
                        "literal": "START_APP"
                    }
                },
                {
                    "id": 6,
                    "name": "lengthOfStay",
                    "type": {
                        "type": "Literal",
                        "literal": 1
                    }
                },
                {
                    "id": 7,
                    "name": "revision",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 8,
                    "name": "createdAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 9,
                    "name": "createdBy",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 10,
                    "name": "updatedAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 11,
                    "name": "updatedBy",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                }
            ]
        },
        "../types/TencentAdsRetentionManagement/TencentAdsRetentionMode": {
            "type": "Union",
            "members": [
                {
                    "id": 0,
                    "type": {
                        "type": "Literal",
                        "literal": "off"
                    }
                },
                {
                    "id": 1,
                    "type": {
                        "type": "Literal",
                        "literal": "capture"
                    }
                },
                {
                    "id": 2,
                    "type": {
                        "type": "Literal",
                        "literal": "live"
                    }
                }
            ]
        },
        "../types/TencentAdsRetentionManagement/TencentAdsRetentionRuntimeStatus": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "runtimeMode",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Reference",
                                    "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionMode"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "unknown"
                                }
                            }
                        ]
                    }
                },
                {
                    "id": 1,
                    "name": "workerEnabled",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "workerHealthy",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "workerHeartbeatAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "configRevision",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "configInSync",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 6,
                    "name": "eventDefinitionHashAvailable",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 7,
                    "name": "lastConfigReloadAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 8,
                    "name": "lastAttemptAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 9,
                    "name": "lastSucceededAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 10,
                    "name": "lastError",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 11,
                    "name": "queue",
                    "type": {
                        "type": "Reference",
                        "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionQueueStats"
                    }
                },
                {
                    "id": 12,
                    "name": "liveGate",
                    "type": {
                        "type": "Reference",
                        "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionLiveGate"
                    }
                }
            ]
        },
        "../types/TencentAdsRetentionManagement/TencentAdsRetentionQueueStats": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "waitingActivation",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 1,
                    "name": "captured",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 2,
                    "name": "pending",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 3,
                    "name": "reporting",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 4,
                    "name": "succeeded",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 5,
                    "name": "failed",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 6,
                    "name": "deadLetter",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 7,
                    "name": "skipped",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 8,
                    "name": "unknown",
                    "type": {
                        "type": "Number"
                    }
                }
            ]
        },
        "../types/TencentAdsRetentionManagement/TencentAdsRetentionLiveGate": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "desiredLive",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 1,
                    "name": "desiredNotPaused",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 2,
                    "name": "actionConfirmed",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 3,
                    "name": "runtimeLive",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 4,
                    "name": "workerEnabled",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 5,
                    "name": "configInSync",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 6,
                    "name": "eventDefinitionReady",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 7,
                    "name": "ready",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 8,
                    "name": "blockedReasons",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "String"
                        }
                    }
                }
            ]
        },
        "../types/TencentAdsRetentionManagement/TencentAdsRetentionOverviewSummary": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "total",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 1,
                    "name": "waitingActivation",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 2,
                    "name": "captured",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 3,
                    "name": "pending",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 4,
                    "name": "reporting",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 5,
                    "name": "succeeded",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 6,
                    "name": "failed",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 7,
                    "name": "deadLetter",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 8,
                    "name": "skipped",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 9,
                    "name": "unknown",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 10,
                    "name": "withClickId",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 11,
                    "name": "successRate",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 12,
                    "name": "oldestWaitingAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                }
            ]
        },
        "../types/TencentAdsRetentionManagement/TencentAdsRetentionTrendRow": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "date",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "total",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 2,
                    "name": "succeeded",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 3,
                    "name": "failed",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 4,
                    "name": "deadLetter",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 5,
                    "name": "skipped",
                    "type": {
                        "type": "Number"
                    }
                }
            ]
        },
        "../types/TencentAdsRetentionManagement/TencentAdsRetentionAuditRow": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "id",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "action",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "save_config"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "retry_reports"
                                }
                            },
                            {
                                "id": 2,
                                "type": {
                                    "type": "String"
                                }
                            }
                        ]
                    }
                },
                {
                    "id": 2,
                    "name": "actorName",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 3,
                    "name": "actorRole",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "reason",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "beforeRevision",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 6,
                    "name": "afterRevision",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 7,
                    "name": "requestedCount",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 8,
                    "name": "changedCount",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 9,
                    "name": "createdAt",
                    "type": {
                        "type": "Number"
                    }
                }
            ]
        },
        "editor/PtlGetTencentAdsRetentionReports/ReqGetTencentAdsRetentionReports": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "page",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 1,
                    "name": "pageSize",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "startTime",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "endTime",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "statuses",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "Reference",
                            "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionStatus"
                        }
                    },
                    "optional": true
                },
                {
                    "id": 5,
                    "name": "cohortDate",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 6,
                    "name": "returnDate",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 7,
                    "name": "userId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 8,
                    "name": "attributionChannel",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 9,
                    "name": "providerCode",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "String"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 10,
                    "name": "sortOrder",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "asc"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "desc"
                                }
                            }
                        ]
                    },
                    "optional": true
                }
            ]
        },
        "../types/TencentAdsRetentionManagement/TencentAdsRetentionStatus": {
            "type": "Union",
            "members": [
                {
                    "id": 0,
                    "type": {
                        "type": "Literal",
                        "literal": "waiting_activation"
                    }
                },
                {
                    "id": 1,
                    "type": {
                        "type": "Literal",
                        "literal": "captured"
                    }
                },
                {
                    "id": 2,
                    "type": {
                        "type": "Literal",
                        "literal": "pending"
                    }
                },
                {
                    "id": 3,
                    "type": {
                        "type": "Literal",
                        "literal": "reporting"
                    }
                },
                {
                    "id": 4,
                    "type": {
                        "type": "Literal",
                        "literal": "succeeded"
                    }
                },
                {
                    "id": 5,
                    "type": {
                        "type": "Literal",
                        "literal": "failed"
                    }
                },
                {
                    "id": 6,
                    "type": {
                        "type": "Literal",
                        "literal": "dead_letter"
                    }
                },
                {
                    "id": 7,
                    "type": {
                        "type": "Literal",
                        "literal": "skipped"
                    }
                }
            ]
        },
        "editor/PtlGetTencentAdsRetentionReports/ResGetTencentAdsRetentionReports": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "total",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 1,
                                "name": "accessibleTotal",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 2,
                                "name": "maxAccessibleRecords",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 3,
                                "name": "page",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 4,
                                "name": "pageSize",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 5,
                                "name": "rows",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Reference",
                                        "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionReportRow"
                                    }
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "../types/TencentAdsRetentionManagement/TencentAdsRetentionReportRow": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "id",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "userId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "cohortDate",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "returnDate",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "timezone",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "Asia/Shanghai"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "String"
                                }
                            }
                        ]
                    }
                },
                {
                    "id": 5,
                    "name": "retentionDay",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 6,
                    "name": "actionType",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 7,
                    "name": "actionId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 8,
                    "name": "actionTime",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 9,
                    "name": "platform",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 10,
                    "name": "attributionChannel",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 11,
                    "name": "hasClickId",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 12,
                    "name": "hasWechatIdentity",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                },
                {
                    "id": 13,
                    "name": "status",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Reference",
                                    "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionStatus"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "String"
                                }
                            }
                        ]
                    }
                },
                {
                    "id": 14,
                    "name": "attempts",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 15,
                    "name": "retryable",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 16,
                    "name": "promotableCaptured",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 17,
                    "name": "providerCode",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "String"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 18,
                    "name": "providerMessage",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 19,
                    "name": "providerTraceId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 20,
                    "name": "lastError",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 21,
                    "name": "skipReason",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 22,
                    "name": "createdAt",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 23,
                    "name": "updatedAt",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 24,
                    "name": "lastAttemptAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 25,
                    "name": "nextRetryAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 26,
                    "name": "reportedAt",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlRetryAdRevenueReports/ReqRetryAdRevenueReports": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "reportIds",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "String"
                        }
                    }
                },
                {
                    "id": 1,
                    "name": "reason",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlRetryAdRevenueReports/ResRetryAdRevenueReports": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "requestedCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 1,
                                "name": "matchedCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 2,
                                "name": "retriedCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 3,
                                "name": "skippedCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 4,
                                "name": "skippedItems",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Reference",
                                        "target": "../types/AdRevenueManagement/AdRevenueRetrySkippedItem"
                                    }
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "../types/AdRevenueManagement/AdRevenueRetrySkippedItem": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "id",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "status",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "reason",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "invalid_id"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "not_found"
                                }
                            },
                            {
                                "id": 2,
                                "type": {
                                    "type": "Literal",
                                    "literal": "not_retryable"
                                }
                            },
                            {
                                "id": 3,
                                "type": {
                                    "type": "Literal",
                                    "literal": "event_definition_runtime_unavailable"
                                }
                            },
                            {
                                "id": 4,
                                "type": {
                                    "type": "Literal",
                                    "literal": "event_definition_unbound"
                                }
                            },
                            {
                                "id": 5,
                                "type": {
                                    "type": "Literal",
                                    "literal": "event_definition_mismatch"
                                }
                            },
                            {
                                "id": 6,
                                "type": {
                                    "type": "Literal",
                                    "literal": "event_definition_invalid"
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "editor/PtlRetryTencentAdsRetentionReports/ReqRetryTencentAdsRetentionReports": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "reportIds",
                    "type": {
                        "type": "Array",
                        "elementType": {
                            "type": "String"
                        }
                    }
                },
                {
                    "id": 1,
                    "name": "reason",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "promoteCaptured",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlRetryTencentAdsRetentionReports/ResRetryTencentAdsRetentionReports": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "requestedCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 1,
                                "name": "matchedCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 2,
                                "name": "retriedCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 3,
                                "name": "promotedCapturedCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 4,
                                "name": "skippedCount",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 5,
                                "name": "skippedItems",
                                "type": {
                                    "type": "Array",
                                    "elementType": {
                                        "type": "Reference",
                                        "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionRetrySkippedItem"
                                    }
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "../types/TencentAdsRetentionManagement/TencentAdsRetentionRetrySkippedItem": {
            "type": "Interface",
            "properties": [
                {
                    "id": 0,
                    "name": "id",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "status",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "reason",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "invalid_id"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "not_found"
                                }
                            },
                            {
                                "id": 2,
                                "type": {
                                    "type": "Literal",
                                    "literal": "not_retryable"
                                }
                            },
                            {
                                "id": 3,
                                "type": {
                                    "type": "Literal",
                                    "literal": "captured_promotion_not_requested"
                                }
                            },
                            {
                                "id": 4,
                                "type": {
                                    "type": "Literal",
                                    "literal": "captured_promotion_gate_closed"
                                }
                            },
                            {
                                "id": 5,
                                "type": {
                                    "type": "Literal",
                                    "literal": "event_definition_runtime_unavailable"
                                }
                            },
                            {
                                "id": 6,
                                "type": {
                                    "type": "Literal",
                                    "literal": "event_definition_unbound"
                                }
                            },
                            {
                                "id": 7,
                                "type": {
                                    "type": "Literal",
                                    "literal": "event_definition_mismatch"
                                }
                            },
                            {
                                "id": 8,
                                "type": {
                                    "type": "Literal",
                                    "literal": "event_definition_invalid"
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "editor/PtlSaveAdRevenueConfig/ReqSaveAdRevenueConfig": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "scope",
                    "type": {
                        "type": "Reference",
                        "target": "../types/AdRevenueManagement/AdRevenueConfigScope"
                    }
                },
                {
                    "id": 1,
                    "name": "adType",
                    "type": {
                        "type": "Reference",
                        "target": "../types/AdRevenueManagement/AdRevenueAdType"
                    }
                },
                {
                    "id": 2,
                    "name": "adUnitId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 3,
                    "name": "adPlacementName",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 4,
                    "name": "revenueCent",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 5,
                    "name": "effectiveFrom",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 6,
                    "name": "expectedRevision",
                    "type": {
                        "type": "Number"
                    },
                    "optional": true
                },
                {
                    "id": 8,
                    "name": "replaceConfigId",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                },
                {
                    "id": 7,
                    "name": "applyToWaiting",
                    "type": {
                        "type": "Boolean"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlSaveAdRevenueConfig/ResSaveAdRevenueConfig": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "status",
                                "type": {
                                    "type": "Union",
                                    "members": [
                                        {
                                            "id": 0,
                                            "type": {
                                                "type": "Literal",
                                                "literal": "saved"
                                            }
                                        },
                                        {
                                            "id": 1,
                                            "type": {
                                                "type": "Literal",
                                                "literal": "revision_conflict"
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                "id": 1,
                                "name": "config",
                                "type": {
                                    "type": "Reference",
                                    "target": "../types/AdRevenueManagement/AdRevenueConfigRow"
                                },
                                "optional": true
                            },
                            {
                                "id": 2,
                                "name": "current",
                                "type": {
                                    "type": "Reference",
                                    "target": "../types/AdRevenueManagement/AdRevenueConfigRow"
                                },
                                "optional": true
                            },
                            {
                                "id": 3,
                                "name": "configVersion",
                                "type": {
                                    "type": "Number"
                                }
                            },
                            {
                                "id": 4,
                                "name": "appliedWaitingCount",
                                "type": {
                                    "type": "Number"
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "editor/PtlSaveTencentAdsRetentionConfig/ReqSaveTencentAdsRetentionConfig": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "mode",
                    "type": {
                        "type": "Reference",
                        "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionMode"
                    }
                },
                {
                    "id": 1,
                    "name": "paused",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 2,
                    "name": "confirmed",
                    "type": {
                        "type": "Boolean"
                    }
                },
                {
                    "id": 3,
                    "name": "apiVersion",
                    "type": {
                        "type": "Literal",
                        "literal": "v3.0"
                    }
                },
                {
                    "id": 4,
                    "name": "timezone",
                    "type": {
                        "type": "Literal",
                        "literal": "Asia/Shanghai"
                    }
                },
                {
                    "id": 5,
                    "name": "expectedRevision",
                    "type": {
                        "type": "Number"
                    }
                },
                {
                    "id": 6,
                    "name": "reason",
                    "type": {
                        "type": "String"
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlSaveTencentAdsRetentionConfig/ResSaveTencentAdsRetentionConfig": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "status",
                                "type": {
                                    "type": "Union",
                                    "members": [
                                        {
                                            "id": 0,
                                            "type": {
                                                "type": "Literal",
                                                "literal": "saved"
                                            }
                                        },
                                        {
                                            "id": 1,
                                            "type": {
                                                "type": "Literal",
                                                "literal": "revision_conflict"
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                "id": 1,
                                "name": "config",
                                "type": {
                                    "type": "Reference",
                                    "target": "../types/TencentAdsRetentionManagement/TencentAdsRetentionConfigRow"
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "editor/PtlUpdateManagedUser/ReqUpdateManagedUser": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "userId",
                    "type": {
                        "type": "String"
                    }
                },
                {
                    "id": 1,
                    "name": "role",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "player"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "gm"
                                }
                            },
                            {
                                "id": 2,
                                "type": {
                                    "type": "Literal",
                                    "literal": "admin"
                                }
                            }
                        ]
                    },
                    "optional": true
                },
                {
                    "id": 2,
                    "name": "status",
                    "type": {
                        "type": "Union",
                        "members": [
                            {
                                "id": 0,
                                "type": {
                                    "type": "Literal",
                                    "literal": "active"
                                }
                            },
                            {
                                "id": 1,
                                "type": {
                                    "type": "Literal",
                                    "literal": "banned"
                                }
                            }
                        ]
                    },
                    "optional": true
                }
            ]
        },
        "editor/PtlUpdateManagedUser/ResUpdateManagedUser": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Reference",
                        "target": "../types/UserManagement/ManagedUserSummary"
                    }
                }
            ]
        },
        "editor/PtlUploadAssetBundle/ReqUploadAssetBundle": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "name",
                    "type": {
                        "type": "String"
                    }
                }
            ]
        },
        "editor/PtlUploadAssetBundle/ResUploadAssetBundle": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ]
        },
        "PtlLoginWithToken/ReqLoginWithToken": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ]
        },
        "PtlLoginWithToken/ResLoginWithToken": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ]
        },
        "PtlLoginWithUsername/ReqLoginWithUsername": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "username",
                                "type": {
                                    "type": "String"
                                }
                            },
                            {
                                "id": 1,
                                "name": "password",
                                "type": {
                                    "type": "String"
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "PtlLoginWithUsername/ResLoginWithUsername": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "String"
                    }
                }
            ]
        },
        "PtlRegister/ReqRegister": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseRequest"
                    }
                }
            ],
            "properties": [
                {
                    "id": 0,
                    "name": "data",
                    "type": {
                        "type": "Interface",
                        "properties": [
                            {
                                "id": 0,
                                "name": "username",
                                "type": {
                                    "type": "String"
                                }
                            },
                            {
                                "id": 1,
                                "name": "password",
                                "type": {
                                    "type": "String"
                                }
                            },
                            {
                                "id": 2,
                                "name": "platform",
                                "type": {
                                    "type": "Reference",
                                    "target": "../types/enums/Platform"
                                },
                                "optional": true
                            },
                            {
                                "id": 3,
                                "name": "email",
                                "type": {
                                    "type": "String"
                                },
                                "optional": true
                            },
                            {
                                "id": 4,
                                "name": "phone",
                                "type": {
                                    "type": "String"
                                },
                                "optional": true
                            },
                            {
                                "id": 5,
                                "name": "nickname",
                                "type": {
                                    "type": "String"
                                },
                                "optional": true
                            },
                            {
                                "id": 6,
                                "name": "role",
                                "type": {
                                    "type": "Union",
                                    "members": [
                                        {
                                            "id": 0,
                                            "type": {
                                                "type": "Literal",
                                                "literal": "player"
                                            }
                                        },
                                        {
                                            "id": 1,
                                            "type": {
                                                "type": "Literal",
                                                "literal": "gm"
                                            }
                                        },
                                        {
                                            "id": 2,
                                            "type": {
                                                "type": "Literal",
                                                "literal": "admin"
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "PtlRegister/ResRegister": {
            "type": "Interface",
            "extends": [
                {
                    "id": 0,
                    "type": {
                        "type": "Reference",
                        "target": "base/BaseResponse"
                    }
                }
            ]
        }
    }
};